class UIRegistry {
  play?: (newAudioSrc: string) => void;
}

export const uiRegistry = new UIRegistry();
